import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class ModalImageMaxTags extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    _close(){
        this.props.setLeave(false);
    }

    _set(){
        this.props.setLeave(true);
    }

    _renderText(item) {
        return langRegister.get("modal-imagemaxtags", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              <div className={Styles.overlayModalTitle}>
                                  {this._renderText("item_1")}
                              </div>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.overlayModalText}>
                                  {this._renderText("item_4")}{' '}
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  ok
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalImageMaxTags;


// WEBPACK FOOTER //
// ./src/components/modal-imagemaxtags/component.js